import React, { useState } from 'react';
import { supabase } from '../supabase';
import './InternsVolunteers.css';

const InternsVolunteers = () => {
  const [activeSection, setActiveSection] = useState('overview');
  const [showApplication, setShowApplication] = useState(false);
  const [formStatus, setFormStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    country: '',
    position: '',
    availability: '',
    message: ''
  });

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFormStatus(null);
  
    try {
      const { error } = await supabase
        .from('intern_applications')
        .insert([{
          full_name: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          country: formData.country,
          position_applied: formData.position,
          availability: formData.availability,
          message: formData.message
        }]);
  
      if (error) throw error;
      
      setFormStatus('success');
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        country: '',
        position: '',
        availability: '',
        message: ''
      });
      setShowApplication(false);
    } catch (error) {
      console.error('Error submitting application:', error);
      setFormStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <section className="page-hero">
        <h1>Interns & Volunteers</h1>
        <p>Join the ABVIG team and gain invaluable experience</p>
      </section>

      <section className="interns-nav">
        <div className="container">
          <div className="nav-tabs">
            <button 
              className={`nav-tab ${activeSection === 'overview' ? 'active' : ''}`}
              onClick={() => scrollToSection('overview')}
            >
              Overview
            </button>
            <button 
              className={`nav-tab ${activeSection === 'duties' ? 'active' : ''}`}
              onClick={() => scrollToSection('duties')}
            >
              Duties & Responsibilities
            </button>
            <button 
              className={`nav-tab ${activeSection === 'positions' ? 'active' : ''}`}
              onClick={() => scrollToSection('positions')}
            >
              Available Positions
            </button>
            <button 
              className={`nav-tab ${activeSection === 'opportunities' ? 'active' : ''}`}
              onClick={() => scrollToSection('opportunities')}
            >
              Opportunities
            </button>
            <button 
              className={`nav-tab ${activeSection === 'apply' ? 'active' : ''}`}
              onClick={() => scrollToSection('apply')}
            >
              How to Apply
            </button>
          </div>
        </div>
      </section>

      <section className="interns-page-section">
        <div className="container">
          <div id="overview" className="interns-section">
            <div className="interns-header">
              <h2>AFRICA BUSINESS AND INVESTMENT GROUP LLC (ABVIG)</h2>
              <h3>AFRICA BUSINESS AND INVESTMENTS INTERNATIONAL NIGERIA LTD</h3>
              <h4>TERMS OF REFERENCE / INTERNS & VOLUNTEERS</h4>
            </div>
            <div className="interns-intro">
              <p>
                ABVIG offers a unique opportunity for passionate individuals to gain hands-on experience 
                in the African business landscape. Our Internship and Volunteer Program is designed to 
                provide practical exposure, professional development, and meaningful contributions to 
                our mission of connecting Africa to the world.
              </p>
            </div>
          </div>

          <div id="duties" className="interns-section">
            <h2 className="section-title">Duties & Responsibilities</h2>
            
            <div className="duties-content">
              <h3>1. What will the Interns and Volunteers do in ABVIG?</h3>
              <p>They will assist ABVIG in the following areas:</p>
              <ul className="duties-list">
                <li>Support the company ABVIG mission</li>
                <li>Assist in prospecting/marketing and registration of AICIS summit prospective participants and sponsors</li>
                <li>Perform routine office administrative function/customer management</li>
                <li>IEC material development</li>
                <li>Information and communication/website update and improvement</li>
                <li>Business promotion / market research</li>
                <li>Human resource development</li>
                <li>ICT/Website and social media</li>
                <li>Data collation and management</li>
                <li>Accounting/financial management system setup and quick books</li>
              </ul>
            </div>

            <div className="duties-content">
              <h3>4. What duration are they to serve?</h3>
              <p><strong>1-3 months or 3-6 months</strong> - Renewable / negotiable term</p>
            </div>

            <div className="duties-content">
              <h3>5. What logistic arrangement is in place?</h3>
              <ul className="logistics-list">
                <li><strong>Accommodation</strong> - Provided for international volunteers</li>
                <li><strong>Simple furniture and basic living materials</strong> (Cooking utensils)</li>
                <li>
                  <strong>Letter of invitation</strong> to ease visa process/Resident permit acquisition 
                  (Ghana Embassy Abroad, Social Welfare Department/Ministry Manpower Youth Development, 
                  Ministry of Interior)
                </li>
              </ul>
            </div>

            <div className="duties-content">
              <h3>7. Language Skills</h3>
              <p>Officially interns/volunteers must be able to write and speak <strong>English professionally</strong></p>
            </div>

            <div className="duties-content">
              <h3>9. Are there remuneration for interns/volunteers?</h3>
              <p>
                Volunteers are supported with <strong>monthly stipend / allowance of $100 - $300</strong> 
                or more depending on available resources
              </p>
            </div>

            <div className="duties-content">
              <h3>10. What do ABVIG expect volunteers and Interns to come with?</h3>
              <ul className="requirements-list">
                <li>Laptop computer</li>
                <li>Pen drives and other goods that interns and volunteers feel are relevant to their work</li>
              </ul>
            </div>
          </div>

          <div id="positions" className="interns-section">
            <h2 className="section-title">Available Positions</h2>
            <div className="positions-grid">
              <div className="position-card">
                <div className="position-icon">🌍</div>
                <h3>International Business Coordinator</h3>
                <p>Business Consultant</p>
              </div>
              <div className="position-card">
                <div className="position-icon">📊</div>
                <h3>International Business/Market Research Executive</h3>
                <p>Market Research & Analysis</p>
              </div>
              <div className="position-card">
                <div className="position-icon">💻</div>
                <h3>ICT/Website and Social Media Manager</h3>
                <p>Digital & Social Media Management</p>
              </div>
              <div className="position-card">
                <div className="position-icon">🎤</div>
                <h3>International Conference Manager</h3>
                <p>Event & Conference Management</p>
              </div>
            </div>
          </div>

          <div id="opportunities" className="interns-section">
            <h2 className="section-title">Opportunities</h2>
            <div className="opportunities-grid">
              <div className="opportunity-card">
                <span className="opportunity-icon">🌍</span>
                <h3>Global Exposure</h3>
                <p>Exposure to the African business, especially the global business environment</p>
              </div>
              <div className="opportunity-card">
                <span className="opportunity-icon">🤝</span>
                <h3>Networking</h3>
                <p>Networking and collaboration with local and international Business Institutions, networks, Banks, Funding Agencies, government agencies and professionals with diverse businesses and leadership experiences</p>
              </div>
              <div className="opportunity-card">
                <span className="opportunity-icon">📚</span>
                <h3>Professional Development</h3>
                <p>Participation in summit/conferences, workshops and orientations</p>
              </div>
            </div>
          </div>

          <div id="apply" className="interns-section apply-section">
            <h2 className="section-title">How to Apply</h2>
            
            {!showApplication ? (
              <>
                <div className="apply-content">
                  <div className="apply-step">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h3>Request the Application Form</h3>
                      <p>Interested candidates should request the ABVIG Standard Form for Volunteers by emailing:</p>
                      <a href="mailto:info@abvig.com" className="email-link">info@abvig.com</a>
                    </div>
                  </div>
                  <div className="apply-step">
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h3>Complete and Submit</h3>
                      <p>Fill out the application form completely and submit it along with your CV/resume</p>
                    </div>
                  </div>
                  <div className="apply-step">
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h3>Interview & Selection</h3>
                      <p>Shortlisted candidates will be contacted for an interview and further discussions</p>
                    </div>
                  </div>
                  <div className="apply-step">
                    <div className="step-number">4</div>
                    <div className="step-content">
                      <h3>Welcome to ABVIG</h3>
                      <p>Successful applicants will receive an offer letter and join the ABVIG team</p>
                    </div>
                  </div>
                </div>
                <div className="apply-cta">
                  <button className="btn-gold apply-btn" onClick={() => setShowApplication(true)}>
                    Apply Online Now
                  </button>
                </div>
              </>
            ) : (
              <div className="application-form">
                <h3>Intern/Volunteer Application Form</h3>
                
                {formStatus === 'success' && (
                  <div className="form-success">
                    <h3>✓ Application Submitted!</h3>
                    <p>Thank you for your interest. Our team will review your application and contact you soon.</p>
                    <button className="btn-gold" onClick={() => setShowApplication(false)}>Back to Apply</button>
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="form-error">
                    <h3>⚠️ Submission Error</h3>
                    <p>There was a problem submitting your application. Please try again or email us directly.</p>
                  </div>
                )}

                {formStatus !== 'success' && (
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label>Full Name *</label>
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                        placeholder="Your full name"
                      />
                    </div>
                    <div className="form-group">
                      <label>Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="your@email.com"
                      />
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Phone Number</label>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="+234 800 000 0000"
                        />
                      </div>
                      <div className="form-group">
                        <label>Country *</label>
                        <select
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Country</option>
                          <option value="Nigeria">Nigeria</option>
                          <option value="Ghana">Ghana</option>
                          <option value="South Africa">South Africa</option>
                          <option value="Kenya">Kenya</option>
                          <option value="Egypt">Egypt</option>
                          <option value="UK">United Kingdom</option>
                          <option value="USA">United States</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Position Applied For *</label>
                      <select
                        name="position"
                        value={formData.position}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Position</option>
                        <option value="International Business Coordinator">International Business Coordinator</option>
                        <option value="International Business/Market Research Executive">International Business/Market Research Executive</option>
                        <option value="ICT/Website and Social Media Manager">ICT/Website and Social Media Manager</option>
                        <option value="International Conference Manager">International Conference Manager</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Availability</label>
                      <select
                        name="availability"
                        value={formData.availability}
                        onChange={handleChange}
                      >
                        <option value="">Select Availability</option>
                        <option value="1-3 months">1-3 months</option>
                        <option value="3-6 months">3-6 months</option>
                        <option value="6+ months">6+ months</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Message / Why do you want to join ABVIG?</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows="4"
                        placeholder="Tell us why you're interested in joining ABVIG..."
                      ></textarea>
                    </div>
                    <button type="submit" className="btn-gold" disabled={loading}>
                      {loading ? 'Submitting...' : 'Submit Application'}
                    </button>
                    <button type="button" className="btn-outline-gold" onClick={() => setShowApplication(false)}>
                      Cancel
                    </button>
                  </form>
                )}
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default InternsVolunteers;